import Slider, { Settings } from 'react-slick';
import BackgroundCard from 'ui-component/cards/BackgroundCard';
import _map from 'lodash/map';
import { Box } from '@mui/material';
import { ReactNode } from 'react';
import StepCryptoPayment from './StepCryptoPayment';
import StepBuildingCrypto from './StepBuildingCrypto';
import StepJoinOnDiscord from './StepJoinOnDiscord';
import StepBoostWalletSecurity from './StepBoostWalletSecurity';

const settings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
};

interface Steps {
    id: number;
    children: ReactNode;
}

const steps: Steps[] = [
    {
        id: 1,
        children: <StepCryptoPayment />
    },
    {
        id: 2,
        children: <StepBuildingCrypto />
    },
    {
        id: 3,
        children: <StepJoinOnDiscord />
    },
    {
        id: 4,
        children: <StepBoostWalletSecurity />
    }
];

const StepSection = () => {
    return (
        <>
            <Box width="100%" position="relative" className="step-dashboard">
                <Slider {...settings}>
                    {_map(steps, (item) => (
                        <BackgroundCard key={item.id} sx={{ minHeight: { xs: 478, md: 262 } }}>
                            {item.children}
                        </BackgroundCard>
                    ))}
                </Slider>
            </Box>
        </>
    );
};

export default StepSection;
